import React from 'react';
import './styles/Navbar.css'

const NavBar = ()=> {
    return (
        <nav className="navbar">
            <div className="title">Suhan</div>
            <div className="navIcon">
                <div className='first'></div>
                <div className='second'></div>
                <div className='third'></div>
            </div>
        </nav>
    )
}

export default NavBar;

